// src/components/BoardOfEd/components/Program2800.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_2800_CONFIG = {
  fullName: "ATHLETICS & CLUBS",
  docId: "2800",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSupportStaff",
      label: "Positions – Support Staff",
      valueType: "count",
      sources: [
        { block: "Positions", key: "Support Staff" },
        { block: "Positions", key: "Support staff" },
      ],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesSupervision",
      label: "Salaries – Supervision",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Supervision" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSupportStaff",
      label: "Salaries – Support Staff",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Support Staff" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesCoaches",
      label: "Salaries – Coaches",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Coaches" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesAdditionalCoaches",
      label: "Salaries – Additional Coaches",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Additional Coaches" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSummerCoaches",
      label: "Salaries – Summer Coaches",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Summer Coaches" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesLifeguards",
      label: "Salaries – Lifeguards",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Lifeguards" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesIntramurals",
      label: "Salaries – Intramurals",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Intramurals" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesStudyHall",
      label: "Salaries – Study Hall Monitors",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Study Hall Monitors" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesActivityAdvisors",
      label: "Salaries – Activity Advisors",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Activity Advisors" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTransportAthletic",
      label: "Salaries – Transportation/Athletic",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Transportation/Athletic" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTransportActivity",
      label: "Salaries – Transportation/Activity",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Transportation/Activity" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTransportClubs",
      label: "Salaries – Transportation/Clubs",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Transportation/Clubs" }],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "purchasedPhysician",
      label: "Physician",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Physician" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedActivitiesPrograms",
      label: "Activities/Special Programs",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Activities/Special Programs" },
        { block: "Purchased Services", key: "Activities / Special Programs" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedGamePractice",
      label: "Game/Practice Expenses",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Game/Practice Expenses" },
        { block: "Purchased Services", key: "GAME/PRACTICE EXPENSES" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedReconditioningRepairs",
      label: "Reconditioning / Repairs",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Reconditioning/Repairs" },
        { block: "Purchased Services", key: "Reconditioning / Repairs" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedOfficials",
      label: "Officials",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Officials" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedNewspaper",
      label: "G.H.S. Newspaper",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "G.H.S. Newspaper" },
        { block: "Purchased Services", key: "GHS Newspaper" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedLiteraryMagazine",
      label: "Literary Magazine",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Literary Magazine" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedAthleticTraining",
      label: "Athletic Training Services",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Athletic Training Services" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedMathLeague",
      label: "Math League",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Math League" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedVehicleRental",
      label: "Vehicle Rental",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Vehicle Rental" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedInsurance",
      label: "Insurance",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Insurance" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "purchasedLeasedSpace",
      label: "Leased Space",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Leased Space" }],
      group: "purchased Services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "suppliesUniforms",
      label: "Supplies / Uniforms",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Supplies/Uniforms" },
        { block: "Supplies / Materials", key: "Supplies / Uniforms" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology – Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology - Software" },
        { block: "Supplies / Materials", key: "Technology Software" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "elementaryActivityClub",
      label: "Elementary Activity Club",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Elementary Activity Club" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "smithMiddleActivityClub",
      label: "Smith Middle Activity Club",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Smith Middle Activity Club" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "highSchoolActivityClub",
      label: "High School Activity Club",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "High School Activity Club" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // EQUIPMENT
    {
      key: "equipmentNew",
      label: "Equipment – New",
      valueType: "currency",
      sources: [
        { block: "Equipment", key: "New" },
        { block: "Equipment", key: "NEW" },
      ],
      group: "equipment",
      defaultVisible: false,
    },
    {
      key: "equipmentReplacement",
      label: "Equipment – Replacement",
      valueType: "currency",
      sources: [
        { block: "Equipment", key: "Replacement" },
        { block: "Equipment", key: "REPLACEMENT" },
      ],
      group: "equipment",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "leagueDuesExpenses",
      label: "League Dues/Expenses",
      valueType: "currency",
      sources: [
        { block: "Other", key: "League Dues/Expenses" },
        { block: "Other", key: "League Dues & Expenses" },
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsSupportStaff",

        // Salaries
        "salariesSupervision",
        "salariesSupportStaff",
        "salariesCoaches",
        "salariesSummerCoaches",
        "salariesLifeguards",
        "salariesIntramurals",
        "salariesStudyHall",
        "salariesActivityAdvisors",
        "salariesTransportAthletic",
        "salariesTransportActivity",
        "salariesTransportClubs",

        // Purchased Services
        "purchasedPhysician",
        "purchasedActivitiesPrograms",
        "purchasedGamePractice",
        "purchasedReconditioningRepairs",
        "purchasedOfficials",
        "purchasedNewspaper",
        "purchasedLiteraryMagazine",
        "purchasedAthleticTraining",
        "purchasedMathLeague",
        "purchasedVehicleRental",
        "purchasedInsurance",
        "purchasedLeasedSpace",

        // Supplies / Materials
        "suppliesUniforms",
        "technologySoftware",
        "elementaryActivityClub",
        "smithMiddleActivityClub",
        "highSchoolActivityClub",

        // Other
        "leagueDuesExpenses",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsSupportStaff: { minWidth: "110px" },

        // Salaries
        salariesSupervision: { minWidth: "110px" },
        salariesSupportStaff: { minWidth: "110px" },
        salariesCoaches: { minWidth: "100px" },
        salariesSummerCoaches: { minWidth: "140px" },
        salariesLifeguards: { minWidth: "100px" },
        salariesIntramurals: { minWidth: "100px" },
        salariesStudyHall: { minWidth: "130px" },
        salariesActivityAdvisors: { minWidth: "150px" },
        salariesTransportAthletic: { minWidth: "180px" },
        salariesTransportActivity: { minWidth: "180px" },
        salariesTransportClubs: { minWidth: "165px" },

        // Purchased Services
        purchasedPhysician: { minWidth: "100px" },
        purchasedActivitiesPrograms: { minWidth: "140px" },
        purchasedGamePractice: { minWidth: "130px" },
        purchasedReconditioningRepairs: { minWidth: "130px" },
        purchasedOfficials: { minWidth: "100px" },
        purchasedNewspaper: { minWidth: "120px" },
        purchasedLiteraryMagazine: { minWidth: "100px" },
        purchasedAthleticTraining: { minWidth: "140px" },
        purchasedMathLeague: { minWidth: "100px" },
        purchasedVehicleRental: { minWidth: "100px" },
        purchasedInsurance: { minWidth: "100px" },
        purchasedLeasedSpace: { minWidth: "100px" },

        // Supplies / Materials
        suppliesUniforms: { minWidth: "100px" },
        technologySoftware: { minWidth: "100px" },
        elementaryActivityClub: { minWidth: "120px" },
        smithMiddleActivityClub: { minWidth: "120px" },
        highSchoolActivityClub: { minWidth: "120px" },

        // Other
        leagueDuesExpenses: { minWidth: "125px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsSupportStaff",

        // Salaries
        "salariesSupervision",
        "salariesSupportStaff",
        "salariesCoaches",
        "salariesSummerCoaches",
        "salariesLifeguards",
        "salariesIntramurals",
        "salariesStudyHall",
        "salariesActivityAdvisors",
        "salariesTransportAthletic",
        "salariesTransportActivity",
        "salariesTransportClubs",

        // Purchased Services
        "purchasedPhysician",
        "purchasedActivitiesPrograms",
        "purchasedGamePractice",
        "purchasedReconditioningRepairs",
        "purchasedOfficials",
        "purchasedNewspaper",
        "purchasedLiteraryMagazine",
        "purchasedAthleticTraining",
        "purchasedMathLeague",
        "purchasedVehicleRental",
        "purchasedInsurance",
        "purchasedLeasedSpace",

        // Supplies / Materials
        "suppliesUniforms",
        "technologySoftware",
        "elementaryActivityClub",
        "smithMiddleActivityClub",
        "highSchoolActivityClub",

        // Other
        "leagueDuesExpenses",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsSupportStaff: { minWidth: "110px" },

        // Salaries
        salariesSupervision: { minWidth: "110px" },
        salariesSupportStaff: { minWidth: "110px" },
        salariesCoaches: { minWidth: "100px" },
        salariesSummerCoaches: { minWidth: "140px" },
        salariesLifeguards: { minWidth: "100px" },
        salariesIntramurals: { minWidth: "100px" },
        salariesStudyHall: { minWidth: "130px" },
        salariesActivityAdvisors: { minWidth: "150px" },
        salariesTransportAthletic: { minWidth: "180px" },
        salariesTransportActivity: { minWidth: "180px" },
        salariesTransportClubs: { minWidth: "165px" },

        // Purchased Services
        purchasedPhysician: { minWidth: "100px" },
        purchasedActivitiesPrograms: { minWidth: "140px" },
        purchasedGamePractice: { minWidth: "130px" },
        purchasedReconditioningRepairs: { minWidth: "130px" },
        purchasedOfficials: { minWidth: "100px" },
        purchasedNewspaper: { minWidth: "120px" },
        purchasedLiteraryMagazine: { minWidth: "100px" },
        purchasedAthleticTraining: { minWidth: "140px" },
        purchasedMathLeague: { minWidth: "100px" },
        purchasedVehicleRental: { minWidth: "100px" },
        purchasedInsurance: { minWidth: "100px" },
        purchasedLeasedSpace: { minWidth: "100px" },

        // Supplies / Materials
        suppliesUniforms: { minWidth: "100px" },
        technologySoftware: { minWidth: "100px" },
        elementaryActivityClub: { minWidth: "120px" },
        smithMiddleActivityClub: { minWidth: "120px" },
        highSchoolActivityClub: { minWidth: "120px" },

        // Other
        leagueDuesExpenses: { minWidth: "125px" },
      },
    },
  ],
};

export function Program2800(props) {
  return (
    <ProgramBudget programId="2800" config={PROGRAM_2800_CONFIG} {...props} />
  );
}
